import { create } from 'zustand';

interface RecetEditorBridgeState {
  flushSave: (() => void) | null;
}

interface RecetEditorBridgeActions {
  setFlushSave: (fn: (() => void) | null) => void;
}

type RecetEditorBridgeStore = RecetEditorBridgeState & RecetEditorBridgeActions;

export const useRecetEditorBridgeStore = create<RecetEditorBridgeStore>()(set => ({
  flushSave: null,
  setFlushSave: fn => set({ flushSave: fn }),
}));
